"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.167 16.375c.916 0 1.666-.731 1.666-1.625V6.625c0-.894-.75-1.625-1.666-1.625H4.833c-.916 0-1.666.731-1.666 1.625v8.125c0 .894.75 1.625 1.666 1.625H1.5V18h20v-1.625h-3.333zM4.833 6.625h13.334v8.125H4.833V6.625z" }), "ResolutionLarge");
//# sourceMappingURL=ResolutionLarge.js.map